import * as React from "react"
import { createBrowserRouter } from "react-router-dom"
import { Dashboard } from "../pages/Dashboard/Dashboard"
import { Report } from "../pages/Report/Report"
import { Navbar } from "../components/navbar/navbar"
import { Footer } from "../components/footer/footer"
import { Signature } from "../pages/Signature/Signature"
import { SuperUser } from "../pages/SuperUser/SuperUser"
import { Contingency } from "../pages/Contingency/Contingency"
import { ManageNotices } from "../pages/ManageNotices/ManageNotices"
import { PageNotFound404 } from "./PageNotFound404"
import { Login } from "pages/Login/Login"
import "./styles.css"
import { ListCompany } from "pages/Company/list"
import { RegisterCompany } from "pages/Company/register"

const App: React.FC<{ page: JSX.Element }> = ({ ...props }) => {
  const { page } = props
  const userLogged = localStorage.getItem("currentUser")
  if (!userLogged) {
    window.location.pathname = "/"
    return <><Login /></>
  }
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />
          <main
            role="main"
            className="w-100 my-3 p-3"
            id="main"
          >
            {page}
          </main>
          <Footer />
        </div>
      </div>
    </>
  )
}
export const router = createBrowserRouter([
  { path: "*", element: <PageNotFound404 /> },
  { path: "/", element: <Login /> },
  { path: "/dashboard", element: <App page={<Dashboard />} /> },
  { path: "/relatorios", element: <App page={<Report />} /> },
  { path: "/assinaturas", element: <App page={<Signature />} /> },
  { path: "/super-usuario", element: <App page={<SuperUser />} /> },
  { path: "/contingencia", element: <App page={<Contingency />} /> },
  { path: "/gerenciar-avisos", element: <App page={<ManageNotices />} /> },
  { path: "/empresas", element: <App page={<ListCompany />} /> },
  { path: "/empresas/cadastro", element: <App page={<RegisterCompany />} /> },

])





